module.exports = __webpack_public_path__ + "static/media/securityAndCompliance-min.c7f8d347.jpg";